import { Point } from "geojson";
import { DatasetRecord } from "@/types/DatasetRecord";
import { displayCoordinates } from "@/util/helpers";
import { AnyAddress, IDisplaySection, ILocation, locationType } from "@/types";
import { GammaAccuracy } from "@/types/location/location-accuracy";

export class CoordinateLocation implements ILocation {
  readonly geometry!: Point;
  address?: AnyAddress;
  record?: DatasetRecord;
  type: locationType = "Coordinate";
  readonly _data: ILocation;

  constructor(data: ILocation) {
    this._data = data;
    Object.assign(this, data);
  }

  get precisionAccuracy(): GammaAccuracy | undefined {
    return 110;
  }

  get addressLinkRequest() {
    return {
      Coordinates: this.geometry.coordinates,
    };
  }

  get title() {
    return displayCoordinates(this.geometry.coordinates);
  }

  get displaySections(): IDisplaySection[] {
    return [
      {
        name: "Coordinates",
        type: "Coordinate",
        items: [
          {
            value: displayCoordinates(this.geometry.coordinates),
            type: "String",
          },
        ],
      },
    ];
  }

  get urlParams(): Record<string, any> {
    return this._data;
  }
}
